<template>
  <RevIllustration
    :alt="i18n(translations.vodafoneLogo)"
    :height="32"
    src="/img/mobile-plan/vodafone-logo-square.svg"
    :width="32"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './VodafoneLogo.translations'

const i18n = useI18n()
</script>
